import { Observable } from 'rxjs';
import { BaseController } from '~client/controller/base-controller';
import { AvailableSectionListResponse } from '~client/model/available-section-list-response';
import { AvailableSectionsRequest } from '~client/model/available-sections-request';
import { BuyNowOfferGroupRequest } from '~client/model/buy-now-offer-group-request';
import { GetOfferGroupRequest } from '~client/model/get-offer-group-request';
import { SalesGroupTreeResponse } from '~client/model/sales-group-tree-response';
import { SimpleOfferGroupListResponse } from '~client/model/simple-offer-group-list-response';
import { SimpleOfferResponse } from '~client/model/simple-offer-response';

/* User APIs pertaining to Lists/Draws */
export class MarketplaceController extends BaseController {
  /* Allows the user remove a draw entry for the given offer group --- Is that comment right? */
  public getOfferGroups(request: GetOfferGroupRequest): Promise<SimpleOfferGroupListResponse> {
    return this.get('/marketplace/public/offerGroups', request);
  }

  public getBuyNowOfferGroups(
    request: BuyNowOfferGroupRequest,
  ): Promise<SimpleOfferGroupListResponse> {
    return this.get<SimpleOfferGroupListResponse>('/marketplace/public/offerGroups', request);
  }

  /* Allows the user to decline payment for offer in offer group */
  public declineOfferPayment$(offerId: string): Observable<SimpleOfferResponse> {
    return this.post$(`/marketplace/declineOfferPayment?offerId=${offerId}`);
  }

  /* Returns a list of sections which have availability. */
  public getAvailableSections$(
    request: AvailableSectionsRequest,
  ): Observable<AvailableSectionListResponse> {
    return this.get$('/marketplace/public/availableSections', request);
  }

  public getSalesGroupTree(
    marketplaceId: string,
    numberOfTokens: number,
  ): Promise<SalesGroupTreeResponse> {
    return this.get(`/marketplace/public/salesGroupTree`, { marketplaceId, numberOfTokens });
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src332225586/src/modules/client/src/controller/marketplace-controller.ts